export default {"src":"/_next/static/media/2.72ff4a7f.svg","height":110,"width":101,"blurWidth":0,"blurHeight":0};